if (!customElements.get('secondary-menu')) {
  class SecondaryMenu extends HTMLElement {
    constructor() {
      super();
      this.menuWrapper = this.querySelector('[data-secondary-menu-wrapper]');
      this.menuItems = this.querySelectorAll('[data-menu-item]');
      this.menuDrawer = document.querySelector('[data-menu-drawer]');
      var announcementbar_close = document.querySelector('[data-attention-bar-close]');

      if (this.menuWrapper.classList.contains('secondary-menu--active')) {
        this.topPosition();

        // Catch click on secondary menu items
        this.querySelectorAll('[data-menu-item]').forEach((item) => {
          item.addEventListener('click', (e) => {
            e.preventDefault();
            this.itemName = item.dataset.menuItem;
            this.open(this.itemName);
          });
        });

        window.addEventListener('resize', () => {
          // Mobile only
          if (window.screen.width < 768) {
            this.topPosition();
          }
        });
      }
      // Update position when the announcement bar gets closed
      announcementbar_close.addEventListener('click', (e) => {
        this.topPosition();
      });
    }

    topPosition() {
      this.menuWrapper.classList.add('hidden');
      //Set top position based on height announcement bar and header
      const announcementBar = document.querySelector('[data-swiper-slide-index]');
      const header = document.querySelector('[data-header]');
      let headerHeight = header.offsetHeight;
      setTimeout(() => {
        if (announcementBar) {
          let announcementBarHeight = announcementBar.offsetHeight;
          let menuOffset = announcementBarHeight + headerHeight + 8;
          let topPosition = menuOffset + 'px';
          this.menuWrapper.style.top = topPosition;
          this.menuWrapper.classList.remove('hidden');
        } else {
          console.log('announcement bar NOT active');
          let menuOffset = headerHeight + 8;
          let topPosition = menuOffset + 'px';
          this.menuWrapper.style.top = topPosition;
          this.menuWrapper.classList.remove('hidden');
        }
      }, 50);
    }

    // Open menu drawer item that has been clicked in the secondary menu
    open(itemName) {
      this.menuDrawer.querySelectorAll('[data-drawer-item]').forEach((item) => {
        this.menuDrawerItem = item.dataset.drawerItem;
        // Find matching menu drawer item to open
        if (this.menuDrawerItem === itemName) {
          //Open drawer
          document.body.classList.add('menu-drawer-is-open');
          //Open menu drawer item
          item.classList.add('collapsible-is-open');
        }
      });
    }
  }

  window.SecondaryMenu = SecondaryMenu;

  customElements.define('secondary-menu', SecondaryMenu);
}
